import React from 'react';
import { Td } from '@chakra-ui/react';
const WrappableTableCell = ({ children, ...rest }) => {
    const style = {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
    };
    return (React.createElement(Td, { sx: style, ...rest }, children));
};
export default WrappableTableCell;
